import { CardType, DebitOrCredit } from "@/types/enums/payment";
import { BinLookupResult } from "@/types/rainforest";

/**
 * Map Rainforest's BIN lookup to debit vs credit for surcharge decisions.
 * Returns null when lookup failed or data is missing.
 */
export function debitOrCreditFromBinLookup(
  result: BinLookupResult,
): DebitOrCredit | null {
  if (result.status !== "SUCCESS" || !result.data) {
    return null;
  }
  const isCreditCard = result.data.type === CardType.CREDIT;
  return isCreditCard ? DebitOrCredit.CREDIT : DebitOrCredit.DEBIT;
}
